<div #scrollContainer class="scroll-to-category-container">
  <div [ngClass]="{'sticky': isSticky, 'shadow-sm': isSticky}"
       class="horizontal-list-wrapper">
    <div class="col-12 d-flex flex-row horizontal-list">
      <div class="horizontal-list-item-wrapper"
           *ngFor="let category of treatmentCategories">
        <button type="button"
                class="btn horizontal-list-item"
                (click)="scrollToCategory(category.name + 'Id')">
          {{category.name}}
        </button>
      </div>
    </div>
  </div>
</div>
